export function capitalizeFirstLetter(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatarCEP(cepInput: string | null | undefined): string {
  if (!cepInput) {
    return "";
  }

  const digitos = cepInput.replace(/\D/g, '');

  if (digitos.length !== 8) {
    return "";
  }

  const cepFormatado = `${digitos.substring(0, 5)}-${digitos.substring(5)}`;

  return cepFormatado;
}